import { Box, Button, Typography, Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { DrawerHeader } from '../../../components/Drawer/DrawerHeader';

const PeriodicosGenerateConvocatoriaDrawer = ({ selectedIds, setOpen, reloadGrid }: any) => {
    const { t } = useTranslation('periodicos');

    const handleCloseDrawer = () => {
        setOpen('');
    };

    const handleSave = () => {
        console.log(selectedIds);
    };
    return (
        <Box display="flex" flexDirection="column" justifyContent="space-between" height="100%">
            <Grid container flexDirection="column">
                <DrawerHeader
                    onIconClick={handleCloseDrawer}
                    text={t('drawer.convocatoria.title')}
                />
                <Typography sx={{ fontWeight: 'bold', mb: 2, mt: 6 }}>
                    {t('drawer.convocatoria.subtitle')}
                </Typography>
            </Grid>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
                <Button variant="outlined" onClick={handleCloseDrawer} sx={{ mr: 1 }}>
                    {t('drawer.cancel')}
                </Button>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={handleSave}
                    sx={{ textTransform: 'none' }}
                >
                    {t('drawer.save')}
                </Button>
            </Box>
        </Box>
    );
};

export default PeriodicosGenerateConvocatoriaDrawer;
